import { useEffect, useMemo, useState } from "react";
import { LeaderboardApi } from "../../api/LeaderboardApi";
import SteminpeLeaderboard from "./SteminpeLeaderboard";

const leaderboardInfo = {
    heading: "STE'AI'M in PE比賽",
    subHeading: "活力金獎 （累計最高時數者）",
    unit: "",
};

export default function SteminpeLeaderboardTopPlayStudent({
    orgId, skillCode, orgType = "all" }) {
    const [isLoading, setIsLoading] = useState(false);
    const [entries, setEntries] = useState([]);

    useEffect(() => {
        let isMounted = true;

        const loadData = async () => {
            if (!orgId || !skillCode) {
                setEntries([]);
                return;
            }
            setIsLoading(true);
            try {
                const result = await LeaderboardApi.getTopMemberPlayTimeWithOrgSkill(
                    orgId, skillCode, orgType);
                if (isMounted) setEntries(Array.isArray(result) ? result : []);
            } catch (error) {
                console.error("Failed to fetch top play students:", error);
                if (isMounted) setEntries([]);
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };

        loadData();

        return () => {
            isMounted = false;
        };
    }, [orgId, skillCode, orgType]);

    const leaderboardData = useMemo(
        () =>
            entries.map(
                ({ id, display_name: itemName, org_name: orgName, group_num: groupNumber, rank, total_duration: score, format_total_duration: formattedScore }) => ({
                    id,
                    itemName: `${orgName} - ${itemName}`,
                    groupNumber: groupNumber ?? "",
                    rank,
                    score,
                    formattedScore,
                }),
            ),
        [entries],
    );

    return (
        <SteminpeLeaderboard
            leaderboardInfo={leaderboardInfo}
            leaderboardData={leaderboardData}
            orgType={orgType}
            isLoading={isLoading}
        />
    );
}